import ApiResourceManager from '../ApiResourceManager';

export default class ServiceFeeSettingsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/service-fee-settings',
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/service-fee-settings',
      data,
    });

  remove = () =>
    this.request({
      method: 'DELETE',
      url: '/service-fee-settings',
    });
}
